export const purposeValidation = (element) => {
    const valid = {
        isValid: true,
        message: ""
    }
    const minLength = 40;
    const maxLength = 360;
    
    element = element.trim();

    if(element === '')
    {
        valid.isValid = false;
        valid.message = 'Purpose can not be empty'
    }

    if (element && element.length < minLength && element.length > 0) {
        valid.isValid = false;
        valid.message = `Minimum length should be greater than ${minLength} characters`;
    }
    else if (element && element.length > maxLength) {
        valid.isValid = false;
        valid.message = `Maximum length should be less than ${maxLength} characters`;
    }
    return valid;
}



// WEBPACK FOOTER //
// ./src/components/CreateSite/Step2/Validation/PurposeValidation.js